import {Injectable} from '@angular/core';
import * as SockJS from 'sockjs-client';
import * as Stomp from 'webstomp-client';
import {Observable, Observer, Subscription} from 'rxjs';
import {environment} from '../../environments/environment';
import {HelperService} from './helper.service';
import {AccountService} from "./account.service";

@Injectable({
  providedIn: 'root'
})
export class WstxcbService {
  stompClient = null;

  subscriberTopicBalance = null;

  subscriberTopicTX = null;
  subscriberQueueTX = null;
  subscriberQueueRocket = null;
  subscriberTopicRocket = null;
  subscriberTopicXD = null;
  subscriberQueueXD = null;
  subscriberChatXD = null;


  connection: Promise<any>;
  connectedPromise: any;

  listenerTopicBalance: Observable<any>;
  listenerTopicBalanceObserver: Observer<any>;

  // listener home.component and txcb.component
  listenerTopicTX: Observable<any>;
  listenerTopicTXObserver: Observer<any>;

  listenerTopicRocket: Observable<any>;
  listenerTopicRocketObserver: Observer<any>;

  listenerTopicXD: Observable<any>;
  listenerTopicXDObserver: Observer<any>;

  // listener txcb.component betting
  listenerQueueTX: Observable<any>;
  listenerObserverQueueTX: Observer<any>;

  listenerQueueRocket: Observable<any>;
  listenerObserverQueueRocket: Observer<any>;

  listenerQueueXD: Observable<any>;
  listenerObserverQueueXD: Observer<any>;
  listenerChatXD: Observable<any>;
  listenerObserverChatXD: Observer<any>;

  // listener HisPhien lsp.component
  listenerLSP: Observable<any>;
  listenerObserverLSP: Observer<any>;

  alreadyConnectedOnce = false;
  subscription: Subscription[] = [];

  private _objHisBet: {
    bt: number;
    bx: number;
  };

  get objHisBet() {
    return this._objHisBet;
  }

  set objHisBet(obj) {
    this._objHisBet = obj;
  }

  private _tokenMiniGame: string;
  get tokenMiniGame(): string {
    return this._tokenMiniGame;
  }

  set tokenMiniGame(token: string) {
    this._tokenMiniGame = token;
  }

  private _sessionID: string;
  get sessionID(): string {
    return this._sessionID;
  }

  set sessionID(sessionID: string) {
    this._sessionID = sessionID;
  }

  constructor(
    private hpService: HelperService,
    private accountService: AccountService
  ) {
    if (this.connectedPromise === null) {
      this.connection = this.createConnection();
    }
    this.connection = this.createConnection();
    this.listenerTopicBalance = this.createListenerTopicBalance();
    this.listenerTopicTX = this.createListenerTopicTX();
    this.listenerQueueTX = this.createListenerQueueTX();
    this.listenerLSP = this.createListenerLSP();
    this.listenerTopicRocket = this.createListenerTopicRocket();
    this.listenerQueueRocket = this.createListenerQueueRocket();
    this.listenerTopicXD = this.createListenerTopicXD();
    this.listenerQueueXD = this.createListenerQueueXD();
    this.listenerChatXD = this.createListenerChatXD();
  }

  connect(cb: any) {
    if (this.stompClient && this.stompClient.connected) {
      return;
    }
    if (this.tokenMiniGame) {
      if (this.connectedPromise === null) {
        this.connection = this.createConnection();
      }

      const url = `${environment.endPointWS}/websocket/ws-minigame?access_token=${this.tokenMiniGame}`;
      const socket = new SockJS(url);
      this.stompClient = Stomp.over(socket);
      this.stompClient.debug = () => {
      };
      const header: Stomp.ConnectionHeaders = {};
      this.stompClient.connect(header, () => {
        const urlArr = socket._transport.url.split('/');
        this.sessionID = urlArr[urlArr.length - 2];
        this.alreadyConnectedOnce = !this.alreadyConnectedOnce;
        this.connectedPromise('success');
        this.connectedPromise = null;
        if (cb && typeof cb === 'function') {
          cb();
        }
      });
    } else {
      this.accountService.resetAuth();
      this.hpService.handleError('Error connect MiniGame!');
    }
  }

  disconnect() {
    this.unsubscribe();
    this.alreadyConnectedOnce = false;
    if (this.stompClient !== null) {
      this.stompClient.disconnect();
      this.stompClient = null;
    }
    this.objHisBet = {bt: null, bx: null};
  }

  sendMessage(topic: string, msg: any) {
    if (this.stompClient && this.stompClient.connected) {
      this.stompClient.send(
        topic, // destination
        JSON.stringify(msg), // body
        {} // header
      );
    }
  }

  receiveMessageTopicBalance() {
    return this.listenerTopicBalance;
  }

  receiveMessageTopicTX() {
    return this.listenerTopicTX;
  }

  receiveMessageQueueTX() {
    return this.listenerQueueTX;
  }

  receiveMessageLSP() {
    return this.listenerLSP;
  }

  receiveMessageTopicRocket() {
    return this.listenerTopicRocket;
  }

  receiveMessageQueueRocket() {
    return this.listenerQueueRocket;
  }

  receiveMessageTopicXD() {
    return this.listenerTopicXD;
  }

  receiveMessageQueueXD() {
    return this.listenerQueueXD;
  }

  receiveMessageChatXD() {
    return this.listenerChatXD;
  }

  subscribeTopicBalance(cb?: any) {
    this.connection.then(() => {
      this.subscriberTopicBalance = this.stompClient.subscribe(this.hpService.BALANCE_QUEUE, data => {
        this.listenerTopicBalanceObserver.next(data);
      });
      this.subscription.push(this.subscriberTopicBalance);
      if (cb && typeof cb === 'function') {
        cb();
      }
    });
  }

  subscribeTopicTX(cb?: any) {
    this.connection.then(() => {
      this.subscriberTopicTX = this.stompClient.subscribe(this.hpService.MINI_TOPIC_TX, data => {
       this.listenerTopicTXObserver.next(data);
      });
      this.subscription.push(this.subscriberTopicTX);
      if (cb && typeof cb === 'function') {
        cb();
      }
    });
  }

  subscribeQueueTX() {
    this.connection.then(() => {
      this.subscriberQueueTX = this.stompClient.subscribe(this.hpService.MINI_TOPIC_QUEUE_TX, data => {
        if (this.listenerObserverQueueTX){
          this.listenerObserverQueueTX.next(data);
        }

        if (this.listenerObserverLSP) {
          this.listenerObserverLSP.next(data);
        }
      });
      this.subscription.push(this.subscriberQueueTX);
    });
  }

  subscribeTopicRocket(cb?: any) {
    this.connection.then(() => {
      this.subscriberTopicRocket = this.stompClient.subscribe(this.hpService.MINI_TOPIC_TD, data => {
        this.listenerTopicRocketObserver.next(data);
      });
      this.subscription.push(this.subscriberTopicRocket);
      if (cb && typeof cb === 'function') {
        cb();
      }
    });
  }

  subscribeQueueRocket() {
    this.connection.then(() => {
      this.subscriberQueueRocket = this.stompClient.subscribe(this.hpService.MINI_TOPIC_QUEUE_TD, data => {
        if (this.listenerObserverQueueRocket) {
          this.listenerObserverQueueRocket.next(data);
        }
      });
      this.subscription.push(this.subscriberQueueRocket);
    });
  }

  subscribeTopicXD(cb?: any) {
    this.connection.then(() => {
      this.subscriberTopicXD = this.stompClient.subscribe(this.hpService.MINI_TOPIC_XD, data => {
        this.listenerTopicXDObserver.next(data);
      });
      this.subscription.push(this.subscriberTopicXD);
      if (cb && typeof cb === 'function') {
        cb();
      }
    });
  }

  subscribeQueueXD() {
    this.connection.then(() => {
      this.subscriberQueueXD = this.stompClient.subscribe(this.hpService.MINI_TOPIC_QUEUE_XD, data => {
        if (this.listenerObserverQueueXD) {
          this.listenerObserverQueueXD.next(data);
        }
      });
      this.subscription.push(this.subscriberQueueXD);
    });
  }

  public subscribeChatXD(cb?: any) {
    this.connection.then(() => {
      this.subscriberChatXD = this.stompClient.subscribe(this.hpService.MINI_TOPIC_CHAT_XD, (data) => {
        if(this.listenerObserverChatXD){
          this.listenerObserverChatXD.next(data);
        }
      });
      this.subscription.push(this.subscriberChatXD);
      if (cb && typeof cb === 'function') {
        cb();
      }
    });
  }

  unsubscribe() {
    this.subscription.forEach(subscription => {
      if (subscription !== null) {
        subscription.unsubscribe();
      }
    });
    this.listenerTopicBalance = this.createListenerTopicBalance();
    this.listenerTopicTX = this.createListenerTopicTX();
    this.listenerQueueTX = this.createListenerQueueTX();
    this.listenerLSP = this.createListenerLSP();
    this.listenerTopicRocket = this.createListenerTopicRocket();
    this.listenerQueueRocket = this.createListenerQueueRocket();
    this.listenerTopicXD = this.createListenerTopicXD();
    this.listenerQueueXD = this.createListenerQueueXD();
    this.listenerChatXD = this.createListenerChatXD();
  }

  private createConnection(): Promise<any> {
    return new Promise((resolve, reject) => (this.connectedPromise = resolve));
  }

  private createListenerTopicBalance(): Observable<any> {
    return new Observable(observer => {
      this.listenerTopicBalanceObserver = observer;
    });
  }

  private createListenerTopicTX(): Observable<any> {
    return new Observable(observer => {
      this.listenerTopicTXObserver = observer;
    });
  }

  private createListenerQueueTX(): Observable<any> {
    return new Observable(observer => {
      this.listenerObserverQueueTX = observer;
    });
  }

  private createListenerLSP(): Observable<any> {
    return new Observable(observer => {
      this.listenerObserverLSP = observer;
    });
  }

  private createListenerTopicRocket(): Observable<any> {
    return new Observable(observer => {
      this.listenerTopicRocketObserver = observer;
    });
  }

  private createListenerQueueRocket(): Observable<any> {
    return new Observable(observer => {
      this.listenerObserverQueueRocket = observer;
    });
  }

  private createListenerTopicXD(): Observable<any> {
    return new Observable(observer => {
      this.listenerTopicXDObserver = observer;
    });
  }

  private createListenerQueueXD(): Observable<any> {
    return new Observable(observer => {
      this.listenerObserverQueueXD = observer;
    });
  }

  private createListenerChatXD(): Observable<any> {
    return new Observable(observer => {
      this.listenerObserverChatXD = observer;
    });
  }
}
